<template>
  <div class="fit-window">
    <page-layout :page-data="page"></page-layout>
  </div>
</template>

<script>
import PageLayout from '~/components/page-templates/Default'
import head from '~/mixins/headerMetaData'

export default {
  name: 'Contact',
  components: {
    PageLayout
  },
  mixins: [head],
  async asyncData (context) {
    const pageExists = context.store.getters['pages/doesPageExist']('contact')
    if (pageExists) {
      const pageId = context.store.getters['pages/pageIdFromSlug']('contact')
      let { data } = await context.$axios.get(`/api/pages/${pageId}`).catch((err) => {
        console.log(err)
      })
      if (data) {
        return {
          page: data,
          displayModal: false
        }
      }
    } else {
      // If no page exists set the ID to false
      return {
        page: {
          ID: false,
          displayModal: false
        }
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.fit-window {
  flex: 1;
}
</style>
